import { toast } from "react-toastify";
import { RoleAPI } from "../constants/apiRoutes";
import { roleActions } from "../reducers/role";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewRole = (data, navigate) => {
  return async (dispatch) => {
    dispatch(roleActions.actionStart());
    try {
      await apiService.post(RoleAPI.create(), data);
      dispatch(roleActions.actionSuccess("create"));
    } catch (err) {
      dispatch(roleActions.clearError());
      handleError(err);
    }
  };
};

export const updateRole = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(roleActions.actionStart());
    return apiService
      .put(RoleAPI.update(id), data)
      .then((response) => {
        dispatch(roleActions.actionSuccess("update"));
      })
      .catch((err) => {
        dispatch(roleActions.clearError());
        handleError(err);
      });
  };
};

export const deleteRole = (id) => {
  return (dispatch) => {
    return apiService
      .delete(RoleAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali rolu", {
          theme: "colored",
        });

        dispatch(fetchRoleList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRoleList = () => {
  return (dispatch) => {
    return apiService
      .get(RoleAPI.list())
      .then((response) => {
        dispatch(roleActions.fetchRoleList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRoleFormList = () => {
  return (dispatch) => {
    return apiService
      .get(RoleAPI.form())
      .then((response) => {
        dispatch(roleActions.fetchRoleFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchRoleById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(RoleAPI.getById(id))
      .then((response) => {
        dispatch(roleActions.fetchRoleDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
